<template>
    <div class="UserAccessList">

        <div class="row">
            <div class="col" v-show="enableFilter">
                <user-access-filter-form @onFilter="onFilter"></user-access-filter-form>
            </div>
            <div class="col text-end">
                <button class="btn btn-outline-secondary" @click="fetchUserAccessList">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                        <path
                            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                    </svg>
                </button>
            </div>
        </div>

        <div class="card" v-show="showOnUser()">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <button class="btn btn-primary" @click="onAddSubscriptions(userId, 'premium')">Add premium
                        </button>
                        <button class="btn btn-primary" @click="onAddSubscriptions(userId, 'free')">Add free</button>
                    </div>
                    <div class="col text-end">
                        <button class="btn btn-outline-secondary" @click="fetchUserAccessList">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                 class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                                <path
                                    d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">

            <div class="card-header" v-if="header !== null">
                <h6>{{ header }}</h6>
            </div>

            <div class="card-body">
                <table class="table table-hover table-responsive align-middle">
                    <thead>
                    <tr>
                        <th>id</th>
                        <th>Activity</th>
                        <th>Active until</th>
                        <th>Status</th>
                        <th>Access type</th>
                        <th v-if="!showOnUser()">Email</th>
                        <th>Update Date</th>
                        <th v-if="showOnUser()">Creation date</th>
                        <th v-if="showOnUser()">renew</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, rowId) in userData">
                        <th>{{ row['id'] }}</th>
                        <td :data-origin="'' + row['active']">
                            <choise :value="row['active']" yesValue="Yes" noValue="No"/>
                        </td>
                        <td :title="'' + row['ends_at']">{{ row['ends_at'] | formatDate }}</td>
                        <td>
                            <select v-if="showOnUser()" class="form-select" v-model="row['status']"
                                    @change="onStatusUpdate(row['id'], $event)">
                                <option v-for="(statusName, statusId) in statusList" :value="statusId">
                                    {{ statusName }}
                                </option>
                            </select>
                            <span v-else>{{ row['status_name'] }}</span>
                        </td>
                        <td style="text-transform: capitalize">{{ row['type'] }}</td>
                        <td v-if="!showOnUser()"><a :href="makeUserLink(row)" target="_blank">{{ row['email'] }}</a>
                        </td>
                        <td :title="'' + row['updated_at']">{{ row['updated_at'] | formatDate }}</td>
                        <td :title="'' + row['created_at']" v-if="showOnUser()">
                            {{ row['created_at'] | formatDate }}
                        </td>
                        <td v-if="showOnUser()">
                                <span v-if="row['type'].toLowerCase() === 'premium'">
                                  <date-picker v-model="row['renewDate']"
                                               type="date"
                                               format="YYYY/MM/DD"
                                               :disabled-date="date => date < new Date(Date.now()-86400000)"
                                  >
                                  </date-picker>
                                    <button type="button" class="btn btn-outline-secondary"
                                            @click="onRenew(row)"
                                            v-if="!(row['renewDate'] == null || row['renewDate'] === undefined)"
                                    >renew</button>
                                </span>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="card-footer">

                    <div class="row">

                        <div class="col">
                            <pagination
                                v-model="current_page"
                                @paginate="testCallback"
                                :records="parseInt(rows_total)"
                                :per-page="parseInt(limit)"
                                :options="paginationOptions"
                            />
                        </div>

                        <div class="col-1" style="min-width: 125px;" v-show="hasPageSelect()">
                            <form class="form-floating">
                                <select class="form-select form-select-sm"
                                        @change="current_page=1; fetchUserAccessList()"
                                        v-model="limit">
                                    <option value="7">7</option>
                                    <option value="15">15</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="1000">1000</option>
                                </select>
                                <label>per page:</label>
                            </form>
                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import UserAccessFilterForm from '../components/UserAccessFilterForm'
import DatePicker from "vue2-datepicker"
import moment from 'moment'

export default {
    name: "UserAccessList",
    props: {
        apiUserToken: String,
        header: {
            type: String,
            required: false,
            default: null,
        },
        enableFilter: {
            type: Boolean,
            required: false,
            default: true,
        },
        userId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    components: {
        Pagination,
        UserAccessFilterForm,
        DatePicker,
    },
    mounted() {
        this.filters.userId = this.userId;
        this.fetchUserAccessList()
    },

    data() {
        return {
            isLoading: false,
            showOnUser: () => {
                return this.userId !== null && this.userId > 0;

            },
            hasPageSelect: () => this.rows_total > this.limit,
            userData: {},
            current_page: 1,
            limit: 50,
            rows_total: 0,
            paginationOptions: {
                theme: "bootstrap4",
                edgeNavigation: true,
                texts: {
                    count: "{from} - {to} of {count} records|{count} records|One record",
                    first: "<<<",
                    last: ">>>",
                },
            },
            filters: {
                email: null,
                status: null,
                nodes_pools_group_id: null,
                updated_at_from: null,
                updated_at_to: null,
                userId: null,
            },
            statusList: {
                1: 'Active',
                2: 'Expires',
                3: 'Deactivated',
                4: 'On Hold',
            },
        }
    },
    methods: {
        async onAddSubscriptions(userId, type) {
            const url = window.Laravel.API_HOSTNAME + '/v1/user-access';
            const data = {
                user_id: userId,
                type,
            }

            const res = await fetch(url, {
                method: "PUT",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + this.apiUserToken,
                },
                redirect: "follow",
                body: JSON.stringify(data),
            })

            if (res.status !== 200) {
                this._onErrorStatus(res.status)
                return
            }

            const response = await res.json()

            if (response.data !== undefined) {
                this.userData = response.data
                if (response.meta !== undefined) {
                    this.current_page = response.meta.current_page
                    this.rows_total = response.meta.total
                }
            }
        },

        async onRenew(row) {
            const url = window.Laravel.API_HOSTNAME + '/v1/user-access/prolong/' + row['id'];
            const data = {
                date: moment(row['renewDate']).format('YYYY/MM/DD')
            }

            const res = await fetch(url, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + this.apiUserToken,
                },
                redirect: "follow",
                body: JSON.stringify(data),
            })

            if (res.status !== 200) {
                this._onErrorStatus(res.status)
                return
            }

            const response = await res.json()

            if (response.data !== undefined) {
                for (let i in this.userData) {
                    if (this.userData[i].id === row['id']) {
                        for (let j in response.data) {
                            this.userData[i][j] = response.data[j]
                        }
                        this.userData[i]['renewDate'] = null
                    }
                }
                this.$forceUpdate()
            }
        },
        async onStatusUpdate(userAccessId, event) {
            const url = window.Laravel.API_HOSTNAME + '/v1/user-access/update-status/' + userAccessId;
            const data = {status: event.target.value}

            const res = await fetch(url, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + this.apiUserToken,
                },
                redirect: "follow",
                body: JSON.stringify(data),
            })

            if (res.status !== 200) {
                this._onErrorStatus(res.status)
                return
            }

            const response = await res.json()

            if (response.data !== undefined) {
                for (let i in this.userData) {
                    if (this.userData[i].id === userAccessId) {
                        for (let j in response.data) {
                            this.userData[i][j] = response.data[j]
                        }
                        this.userData[i]['renewDate'] = null
                    }
                }
                this.$forceUpdate()
            }
        },

        onFilter(data) {
            this.filters.email = data.email ?? '';
            this.filters.status = data.status ?? '';
            this.filters.nodes_pools_group_id = data.nodes_pools_group_id ?? '';
            this.filters.updated_at_from = data.updated_at_from ?? '';
            this.filters.updated_at_to = data.updated_at_to ?? '';
            this.fetchUserAccessList()
        },
        testCallback(page) {
            this.current_page = page
            this.fetchUserAccessList()
        },

        makeUserLink(row) {
            return (row['is_tester'] ? '/users/tester/' : '/users/') + row['user_id']
        },

        async fetchUserAccessList() {
            if (this.apiUserToken <= '') {
                const content = document.querySelector('.UserAccessList')
                content.innerHTML = '<div class="alert alert-danger" role="alert">\n' +
                    '  You do not have jwt token. Please relogin' +
                    '</div>'
                return
            }
            if (this.isLoading) return;
            this.isLoading = true;

            const data = {
                page: this.current_page,
                limit: this.limit,
                email: this.filters.email,
                status: this.filters.status,
                nodes_pools_group_id: this.filters.nodes_pools_group_id,
                updated_at_from: this.filters.updated_at_from,
                updated_at_to: this.filters.updated_at_to,
                user_id: this.filters.userId,
            }

            const url = window.Laravel.API_HOSTNAME + '/v1/user-access'

            const res = await fetch(url, {
                method: "POST",
                mode: "cors",
                cache: "no-cache",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': 'Bearer ' + this.apiUserToken,
                },
                redirect: "follow",
                body: JSON.stringify(data),
            })

            if (res.status !== 200) {
                this._onErrorStatus(res.status)
                return
            }

            const response = await res.json()

            if (response !== undefined) {
                this.userData = response.data
                if (response.meta !== undefined) {
                    this.current_page = response.meta.current_page
                    this.rows_total = response.meta.total
                }
            }

            this.isLoading = false;
        },

        _onErrorStatus(status) {
            if (status === 401) {
                location.href = '/logout'
                return false
            }

            if (status === 401) {
                const content = document.querySelector('.UserAccessList')
                content.innerHTML = '<div class="alert alert-danger" role="alert">\n' +
                    '  You do not have permission to view this page.' +
                    '</div>'
                return true
            }
        },
    },
}
</script>
